import {
  createContext,
  ReactNode,
  useContext,
  useState,
  useEffect,
} from "react";
import AuthService from "../../Services/auth.service";

interface AuthContextProps {
  isUserLoggedIn: boolean;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(false);

  useEffect(() => {
    AuthService.getInstance().subscribe(
      AuthService.EVENTS.USER_SIGNED_IN,
      () => {
        setIsUserLoggedIn(true);
      }
    );
    const user = AuthService.getInstance().getCurrentUser();
    setIsUserLoggedIn(!!user);
    AuthService.getInstance().subscribe(
      AuthService.EVENTS.USER_SIGNED_OUT,
      () => {
        setIsUserLoggedIn(false);
      }
    );
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isUserLoggedIn,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
